import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';

const NewsRedirect = ({ isAd }) => {
    const { slug } = useParams();
    const location = useLocation();

    useEffect(() => {
        const handleRedirect = async () => {
            try {
                // Извлекаем click_id из URL-параметров текущей страницы
                const urlParams = new URLSearchParams(window.location.search);
                const clickId = urlParams.get('click_id');
                
                console.log('NewsRedirect: Извлечен click_id из URL:', clickId);
                
                // Формируем конечную точку API с учетом типа редиректа и добавляем click_id
                let endpoint = isAd 
                    ? `/api/out/news/${slug}`
                    : `/api/forward/news/${slug}`;
                    
                // Добавляем click_id как параметр, если он есть
                if (clickId) {
                    endpoint += `?click_id=${encodeURIComponent(clickId)}`;
                    console.log('NewsRedirect: Передаем click_id в редирект API:', endpoint);
                }
                
                const response = await axios.get(endpoint);
                
                if (response.data && response.data.redirectUrl) {
                    window.location.href = response.data.redirectUrl;
                }
            } catch (error) {
                console.error('Ошибка редиректа:', error);
                window.location.href = '/';
            }
        };

        handleRedirect();
    }, [slug, isAd]);

    return null;
};

export default NewsRedirect; 